<template>
    <div v-if='idea_detail' class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout row wrap :class="{'pa-0': $vuetify.breakpoint.xs,'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'px-2': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <v-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text">
                        <router-link :alt="item.text" :to="item.link" class="grey-text">
                            <v-icon v-if="item.id==1" class="mr-1">keyboard_arrow_left</v-icon> {{ item.text }}
                        </router-link>
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
                <v-flex xs12>
                    <v-layout row wrap align-center
                              :class="{'px-3': $vuetify.breakpoint.xs}"
                    >
                        <v-flex>
                            <h1 class="ml-0 my-4 mr-4 font-weight-light" :class="{'headline': $vuetify.breakpoint.xs, 'display-2': $vuetify.breakpoint.lgAndUp}">{{ idea_detail.title }}</h1>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex md8 xs12>
                            <v-layout class="column mb-5" :class="{'pa-3': $vuetify.breakpoint.smAndDown}">
                                <v-layout row wrap align-center
                                          mt-2
                                >
                                    <v-flex pr-4 md3 xs7>
                                        <v-layout>
                                            <div class="mr-2">{{ day(idea_detail.date) }}</div>
                                            <div class="grey-text">{{ time(idea_detail.date) }}</div>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex pr-2 md3 xs5>
                                        <v-layout align-center>
                                            <iconLabel :icon_name="idea_detail.liked ? 'heart-filled' : 'heart'" class="icon-label-red align-content-end" size="23"
                                                       :class="{'pr-3': $vuetify.breakpoint.xs}" @click.native="like_idea(idea_detail.id)"
                                            >{{ idea_detail.likes }}</iconLabel>
                                            <router-link :to="{hash:'#comments'}" class="link--anchor flex" @click.native="jumpToComments()"><iconLabel icon_name="chat" class="icon-label-green" size="20">{{ comments.length }}</iconLabel></router-link>
                                        </v-layout>
                                    </v-flex>
                                    <v-flex class="ideas-item__user" :class="{'mt-2 pr-0': $vuetify.breakpoint.smAndDown, 'pr-4': $vuetify.breakpoint.mdAndUp}">
                                        <div class="ideas-item__user-avatar">
                                            <img :src="idea_detail.author.avatar" alt="avatar" style="width: 40px;height: 40px;">
                                        </div>
                                        <v-layout column align-start>
                                            <span>{{ idea_detail.author.name }}</span>
                                            <v-layout align-center>
                                                <img :src="idea_detail.author.chevron" alt="chevron" class="mt-1"
                                                     width="30px" height="25px"
                                                >
                                                <div class="grey-text">{{ idea_detail.author.rank }}</div>
                                            </v-layout>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-flex mt-3>
                                    <iconLabel icon_name="idea" class="no_pointer grey-text" size="20">{{ idea_detail.theme }}</iconLabel>
                                </v-flex>
                                <v-layout class="mt-4 wrap">
                                    <v-flex v-for="(file, i) in idea_detail.file" :key="i" class="lg4 sm6 xs12"
                                            :class="{'mb-3': $vuetify.breakpoint.xs}"
                                    >
                                        <v-layout align-center :class="{'mr-0': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"
                                                 viewBox="0 0 64 64"
                                            >
                                                <g fill="none" fill-rule="evenodd">
                                                    <path fill="#D5D5D9" d="M40.235 4.52l12.983 13.377-8.439-.073c-2.509-.022-4.544-2-4.544-4.442V4.52zm.774-4.025A1.519 1.519 0 0 0 39.912 0H15.293C10.75 0 7 3.788 7 8.394v47.211C7 60.213 10.75 64 15.293 64h33.415C53.25 64 57 60.213 57 55.605V18.118c0-.402-.183-.788-.442-1.082L41.009.495z" />
                                                    <path fill="#ED6565" d="M0 55h64V31H0z" />
                                                    <text fill="#FFF" font-family="FuturisC" font-size="15">
                                                        <tspan x="16" y="46" class="text-uppercase">{{ file.src.split('.')[1] }}</tspan>
                                                    </text>
                                                    <path fill="#CA4848" d="M0 31.165h7V24.16zM64 31.165h-7V24.16z" />
                                                </g>
                                            </svg>
                                            <v-layout column class="ml-4">
                                                <linkRed :href="file.src" class="text-truncate">{{ file.src.slice(file.src.lastIndexOf('/')+1,file.src.indexOf('.')) }}</linkRed>  <!-- название файла -->
                                                <div class="grey-text text-uppercase">{{ file.src.split('.')[1] }}, {{ file.size }} КБ</div>
                                            </v-layout>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <div class="mt-5 light-font" v-html="idea_detail.text"></div>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                    <v-layout column>
                        <v-layout wrap align-center justify-space-between
                                  :class="{'px-2 mb-4 layout': $vuetify.breakpoint.xs, 'mb-5': $vuetify.breakpoint.smAndUp}"
                        >
                            <div id="comments" class="display-1" :class="{'px-2 mb-2': $vuetify.breakpoint.xs}">{{ $t("Комментарии") }} ({{ comments.length }})</div>
                            <buttonRed slot="activator" :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="OPEN_MODAL('add_comment_modal')">{{ $t("Оставить комментарий") }}</buttonRed>

                        </v-layout>
                        <commentBlock v-for="(comment, i) in paginated" :key="i" :content="comment"
                                      :class="{'background-light': !(i%2)}"
                        />

                        <v-layout v-if="comments.length>10" mb-5 mt-4
                                  justify-space-between
                                  align-center wrap text-xs-center
                                  :class="{'px-3': $vuetify.breakpoint.xs}"
                        >
                            <v-flex lg4 md4
                                    sm6 xs12
                                    :class="{'mb-4': $vuetify.breakpoint.smAndDown}"
                            >
                                <div class="text-xs-center text-sm-left">
                                    <v-pagination
                                        v-model="page"
                                        :length="Math.ceil(idea_detail.comments / selected_number)"
                                        :total-visible="$vuetify.breakpoint.smAndDown ? 4 : 6"
                                        prev-icon="arrow_back_ios"
                                        next-icon="arrow_forward_ios"
                                    />
                                </div>
                            </v-flex>
                            <v-flex md4 sm6 xs12
                                    :class="{'layout': $vuetify.breakpoint.xs, 'mb-4': $vuetify.breakpoint.smAndDown}"
                            >
                                <buttonRed slot="activator" :class="{'flex xs12': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.smAndUp}"
                                           @click.native="OPEN_MODAL('add_comment_modal')"
                                >{{ $t("Оставить комментарий") }}</buttonRed>
                            </v-flex>
                            <v-flex v-if="comments.length>10" md4 sm6
                                    :class="{'mb-4': $vuetify.breakpoint.smAndDown}"
                            >
                                <v-select
                                    :items="$vuetify.breakpoint.mdAndUp ? ['Показывать по 10','Показывать по 25','Показывать по 50','Показывать по 100']
                                    : ['Показывать по 10','Показывать по 25','Показывать по 50']"
                                    solo
                                    append-icon=""
                                    label="Показывать по 10"
                                    class="input"
                                    @change="show_number($event)"
                                >
                                  <template #append>
                                    <v-icon aria-hidden="true" translate="no">
                                      expand_more
                                    </v-icon>
                                  </template>
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-flex>
            </v-layout>
        </div>
        <v-dialog :value="add_comment_modal" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'" persistent>
            <ideaCommentModal />
        </v-dialog>
        <v-dialog :value="edit_comment_modal" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'" persistent>
            <ideaEditCommentModal />
        </v-dialog>
        <v-dialog :value="delete_comment_modal" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'" persistent>
            <ideaCommentDelete />
        </v-dialog>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import linkRed from '@/components/ui/links/styled/link_red.vue';
import iconLabel from '@/components/ui/icons/icon_with_label';
import buttonRed   from '@/components/ui/buttons/button_red';
import ideaModal from './Ideas_bank_modals/Ideas_bank_modal';
import ideaCommentModal from './Ideas_bank_modals/Ideas_add_comment_modal';
import ideaCommentDelete from './Ideas_bank_modals/Ideas_comment_delete';
import ideaEditCommentModal from './Ideas_bank_modals/Ideas_edit_comment_modal';
import commentBlock from './Idea_comment_block';
import ideaBlock from './Idea_block';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    iconLabel,
    buttonRed,
    ideaModal,
    ideaCommentModal,
    ideaCommentDelete,
    ideaEditCommentModal,
    ideaBlock,
    linkIcon,
    linkRed,
    commentBlock,
  },
  data() {
    return {
      id: this.$route.params.id,
    };
  },
  computed: {
    ...mapGetters('ideas_bank', [
      'add_comment_modal',
      'edit_comment_modal',
      'delete_comment_modal',
      'ideas',
      'idea_detail',
    ]),
    ...mapGetters('ideas_bank/comments', [
      'comments',
      'selected_number',
      'selected_page',
      'paginated',
    ]),
    ...mapGetters('ideas_bank/breadcrumbs', [
      'breadcrumbs',
    ]),
    page: {
      get() {
        return this.selected_page;
      },
      set($event) {
        return this.SET_SELECTED_PAGE($event);
      },
    },
  },
  async mounted() {
    this.CURRENT_IDEA(this.$route.params.id);
    await this.get_ideas();
    await this.get_idea_comments();
    setTimeout(()=>{
      this.jumpToComments();
    }, 0 );
  },
  methods: {
    jumpToComments() {
      if (this.$route.hash) {
        let top = document.getElementById('comments').offsetTop;
        window.scrollTo(0, top);
      }
    },
    ...mapMutations('ideas_bank', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
      'CURRENT_IDEA',
    ]),
    ...mapMutations('ideas_bank/comments', [
      'SET_SELECTED_PAGE',
    ]),
    ...mapActions('ideas_bank', [
      'get_ideas',
      'like_idea',
    ]),
    ...mapActions('ideas_bank/comments', [
      'show_number',
      'get_idea_comments',
    ]),
    day(date) {
      return new dayjs(date).format('DD.MM.YYYY');
    },
    time(date) {
      return new dayjs(date).format('HH.MM');
    },
  },
};
</script>
<style lang="less" scoped>
.text-truncate {
  max-width: 200px;
}
</style>

